import { jsonb, pgTable, text, timestamp } from 'drizzle-orm/pg-core';

export const methodsCache = pgTable('methods_cache', {
  method_path: text().primaryKey(),
  data: jsonb(),
  created_at: timestamp().notNull().defaultNow(),
});
